
import { defineComponent } from "vue";
import listItem from "./components/listItem.vue";
export default defineComponent({
  components: {
    listItem
  },
  setup() {}
});
